import * as Yup from "yup";
export const newCheckoutFormValidationSchema = Yup.object({
  // first_name: Yup.string().required("First name is required"),
  name: Yup.string().required("Name is required"),
  email: Yup.string()
    .email("Must be a valid email")
    .required("Email is required"),
  phone: Yup.string()
    .min(7, "Must be a valid phone number")
    .required("Phone number is required"),
  street: Yup.string().required("Street address is required"),
  city: Yup.string().required("City is required"),
  zip: Yup.string().required("Zip code is required"),
  state_id: Yup.number().required("State is required"),
  country_id: Yup.number().required("Country is required"),
});
